export default __webpack_public_path__ + "static/media/img9.02daaa1a.png";